export const PRODUCT_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Producto guardado exitosamente.",
  DISABLE_SUCCESS: "Producto deshabilitado exitosamente.",
  ENABLE_SUCCESS: "Producto habilitado exitosamente.",
};

export const PRODUCT_MESSAGES_ERROR = {
  SAVE_ERROR: "Error al guardar el producto. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR:
    "Error al deshabilitar el producto. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR:
    "Error al habilitar el producto. Por favor, inténtalo de nuevo.",
};
